import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { MetricsElement } from "react-metrics";
import { SSOLogin, SSORegister } from 'modules/Common/reducers/skysso';

// Full width button row for register & login btns
export function RegisterLoginButtons(props) {
  const {
    registerClick = null,
    loginClick = null,
    closeContext = () => {},
    loginLabel = "Log in",
    registerLabel = "Register",
    trackLoginClickAttributes = {},
    trackRegisterClickAttributes = {},
    SSOLogin,
    SSORegister
  } = props


  const onLoginClick = () => {
    
    if (loginClick) {
      loginClick()
    }
    closeContext()
    SSOLogin()
  }

  const onRegisterClick = () => {
    if (registerClick) {
      registerClick()
    }
    closeContext()
    SSORegister()
  }



  return (
    <div className="reglog-button-fw-row">
      <MetricsElement>
        <button {...trackLoginClickAttributes} className="login-button" id="login-btn" onClick={onLoginClick}>{ loginLabel }</button>
      </MetricsElement>
      <MetricsElement>
        <button {...trackRegisterClickAttributes} className="register-button" id="register-btn" onClick={onRegisterClick}>{ registerLabel }</button>
      </MetricsElement>
    </div>
  );
}

RegisterLoginButtons.propTypes = {
  closeContext: PropTypes.func,
  loginLabel: PropTypes.string,
  registerLabel: PropTypes.string,
  registerClick: PropTypes.func,
  loginClick: PropTypes.func,
  trackLoginClickAttributes: PropTypes.object,
  trackRegisterClickAttributes: PropTypes.object,
  SSOLogin: PropTypes.func,
  SSORegister: PropTypes.func
};

const mapDispatchToProps = (dispatch) => {
  return {
    SSOLogin: () => dispatch(SSOLogin()),
    SSORegister: () => dispatch(SSORegister())
  }
}

export default connect(null, mapDispatchToProps)(RegisterLoginButtons);


// WEBPACK FOOTER //
// ./modules/Common/components/RegisterLoginButtons.js